import { View } from "@/components/ui";
import { Divider } from "@/components/shared/divider";

export const ReferralHistorySkeleton = () => {
  return (
    <View>
      {[1, 2, 3].map((_, index) => (
        <View key={index}>
          <View className="flex flex-row items-start gap-3 py-4">
            <View className="relative">
              <View className="h-6 w-6 animate-pulse rounded-full bg-gray-200" />
              <View className="absolute -bottom-0 -right-0 rounded-full bg-white p-px">
                <View className="h-2.5 w-2.5 animate-pulse rounded-full bg-gray-200" />
              </View>
            </View>
            <View className="mr-auto flex flex-col gap-1">
              <View className="h-4 w-32 animate-pulse rounded bg-gray-200" />
              <View className="h-3 w-20 animate-pulse rounded bg-gray-100" />
            </View>
            <View className="h-6 w-12 animate-pulse self-center rounded bg-gray-100" />
          </View>
          {index !== 2 && <Divider />}
          {index === 2 && (
            <View className="flex flex-col items-center py-6">
              <View className="h-10 w-32 animate-pulse rounded-full bg-gray-200" />
            </View>
          )}
        </View>
      ))}
    </View>
  );
};
